/***
 * TO BE REMOVED
 */

export const HOTEL_TAXONOMY_HERITAGE_AWALI_ID =
  "84d7e9a8-d840-40da-b0c1-acc1fbf40545"
export const HOTEL_TAXONOMY_HERITAGE_LE_TELFAIR_ID =
  "0a860d53-0e43-4723-bebc-e4144174a4a2"
export const HOTEL_TAXONOMY_HERITAGE_RESORT_ID =
  "e9a09b4c-d930-454f-9a91-9f755892f127"

/**
 * New constants hotels
 * [
        {
          "name": "Veranda Resorts",
          "drupal_id": "c939cbf4-027e-40eb-a941-4c683d096bb0"
        },
        {
          "name": "Veranda Pointe aux Biches",
          "drupal_id": "708a5a46-6394-4f2d-a3f5-7a063a6ce201"
        },
        {
          "name": "Veranda Tamarin",
          "drupal_id": "8c705b72-3dbc-402e-89ba-3ca707a1d53f"
        },
        {
          "name": "Veranda Palmar Beach",
          "drupal_id": "9f17836a-f3dd-42ae-a89e-e601e7ec5846"
        },
        {
          "name": "Veranda Grand Baie",
          "drupal_id": "0e204f9f-028c-447c-9271-f2a9f94c2d74"
        },
        {
          "name": "Veranda Paul & Virginie",
          "drupal_id": "c2d4a773-ee3f-4b1d-9a29-21eea272203e"
        }
      ]
 */

export const HOTEL_TAXONOMY_VERANDA_RESORTS_ID = "c939cbf4-027e-40eb-a941-4c683d096bb0"
export const HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID = "708a5a46-6394-4f2d-a3f5-7a063a6ce201"
export const HOTEL_TAXONOMY_VERANDA_TAMARIN_ID = "8c705b72-3dbc-402e-89ba-3ca707a1d53f"
export const HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID = "9f17836a-f3dd-42ae-a89e-e601e7ec5846"
export const HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID = "0e204f9f-028c-447c-9271-f2a9f94c2d74"
export const HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID = "c2d4a773-ee3f-4b1d-9a29-21eea272203e"